import { render, staticRenderFns } from "./ObservationsModal.vue?vue&type=template&id=59b18dda"
import script from "./ObservationsModal.vue?vue&type=script&lang=js"
export * from "./ObservationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports